import ApiUrls from '@api/apiUrls';
import { fetchApi } from '@api/fetchApi';

export interface IApiDataChangeRequestUser {
  bankBranchName: string;
  beneficiaryBankName: string;
  beneficiaryAccountNumber: string;
  bankCardFileItem: File;
}

export const apiDataChangeRequestUserService = {
  showDataChangeRequestPopup: async () => {
    return await fetchApi.get<boolean>(ApiUrls.dataChangeRequestUser.showDataChangeRequestPopup);
  },

  create: async (data: FormData) => {
    return await fetchApi.post(ApiUrls.dataChangeRequestUser.create, data);
  },
};
